import styles from './ProgressBar.module.css'

interface ProgressBarProps {
  percent: number
  variant?: 'default' | 'done' | 'warn'
  size?: 'sm' | 'lg'
}

export default function ProgressBar({ percent, variant = 'default', size = 'sm' }: ProgressBarProps) {
  const clamped = Math.min(100, Math.max(0, percent))
  const toneClass =
    variant === 'done' ? styles.fillDone : variant === 'warn' ? styles.fillWarn : undefined

  return (
    <div className={[styles.track, size === 'lg' && styles.trackLg].filter(Boolean).join(' ')}>
      <span
        className={[styles.fill, toneClass].filter(Boolean).join(' ')}
        style={{ width: `${clamped}%` }}
      />
    </div>
  )
}
